import React, { useEffect } from 'react'
import { Modal, Button } from "react-bootstrap"
import { useCookies } from 'react-cookie'
//import { window } from "browser-monads"

function IFAModal(props) {

  const modalTitle = "Important Information"

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      className="modal-ifa"
    >
      <Modal.Header>
      </Modal.Header>
      <Modal.Body>
        <p className="hr hr--top modal__title">{modalTitle}</p>
        <p>This area of the website is intended solely for investment advisers, accountants, solicitors and any other professional financial intermediaries who are authorised and regulated by the Financial Conduct Authority. This information must not be distributed to, or relied upon by, private clients and the general public.</p><p><strong>Investment involves risk. The investments discussed in this section of the website may not be suitable for all investors. The value of investments and the income from them can go down as well as up and investors may not get back the amount originally invested.</strong></p>
        <p>The website is for information purposes only and has no regard for the specific investment objectives, financial situation or needs of any specific investor.</p><p>Please click below to confirm that you are a&nbsp;UK investment adviser or a professional financial intermediary, and that you have read and agreed to the important information above.</p><p>By clicking accept below you confirm that you read the important information and wish to continue to this site.</p>
      </Modal.Body>
      <Modal.Footer>
      <Button size="sm" variant="secondary" href='/homepage'>Decline</Button>
      <Button size="sm" onClick={props.onHide}>Accept</Button>
      </Modal.Footer>
    </Modal>
  );
}



function ModalIFA(props) {

  // launch modal for IFAs?
  const [modalShow, setModalShow] = React.useState(false)
  const modalPathTest = "/financial-advisers"
  const [cookies, setCookie] = useCookies(['jmf_ifa'])
  // lanch modal if test passes and no cookie set
  useEffect(() => {
    if(window.location.href.indexOf(modalPathTest) > 0){
      if(!cookies.jmf_ifa) setModalShow(true)
    }
  })


  return (
    <>
      <IFAModal
        key="ifa-modal"
        show={modalShow}
        onHide={() => {
          setModalShow(false);
          setCookie('jmf_ifa', 'accept', { path: '/' });
        }}
      />
    </>
  )
}

export default ModalIFA

